module.exports = __webpack_public_path__ + "img/22.30c2d0ca.png";